import React from 'react';
import { Trophy } from 'lucide-react';

export default function SportsTeamHero() {
  const scrollToGenerator = () => {
    document.getElementById('sports-team-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="https://images.unsplash.com/photo-1461896836934-ffe607ba8211?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          alt="Sports team celebrating"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-indigo-900 via-indigo-800 to-indigo-900 opacity-80"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <div className="flex justify-center mb-6">
          <Trophy className="w-16 h-16 text-indigo-400 animate-bounce" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          Sports Team Name Generator
        </h1>
        <p className="text-xl text-indigo-100 mb-8 max-w-3xl mx-auto">
          Create the perfect name for your sports team with our AI-powered generator.
          From local leagues to professional teams, we've got you covered.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <span className="bg-indigo-700/50 px-4 py-2 rounded-full text-white text-sm border border-indigo-500/30">
            Professional Teams
          </span>
          <span className="bg-indigo-700/50 px-4 py-2 rounded-full text-white text-sm border border-indigo-500/30">
            League Names
          </span>
          <span className="bg-indigo-700/50 px-4 py-2 rounded-full text-white text-sm border border-indigo-500/30">
            Multiple Sports
          </span>
        </div>
        <button 
          onClick={scrollToGenerator}
          className="bg-indigo-500 text-white text-lg px-8 py-4 rounded-lg hover:bg-indigo-600 transition-all cursor-pointer transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2 mx-auto"
        >
          <Trophy className="w-5 h-5" />
          Generate Team Names
        </button>
        <p className="mt-6 text-sm text-indigo-200 bg-indigo-800/30 inline-block px-4 py-2 rounded-full mx-auto">
          Trusted by over 10,000+ teams worldwide
        </p>
      </div>
    </div>
  );
}